export default __webpack_public_path__ + "static/badge-red-1a1a6c2de10eb40ae2cc071a4d69d577.png";